import { toast } from 'sonner';
import { api, getBlobApiErrorMessage } from '../api/client';
import {
  POPUP_BLOCKED_MESSAGE,
  PRINT_IN_TAB_MESSAGE,
  claimBlobTab,
  saveBlobAs,
  showBlobInTab,
} from './blob-tab';

/**
 * A safety-form submission's PDF: save it, or open it in a tab to print.
 *
 * Print goes through a tab on every device, not a hidden frame. A tab is the
 * one path that prints a PDF on a phone as well as a desktop (see blob-tab's
 * printing notes). The tab is claimed BEFORE the await, while the click still
 * counts as a user gesture, or the browser drops it silently.
 */

export function submissionPdfFilename(templateName: string | null | undefined, id: string): string {
  const base = (templateName || 'safety-form').replace(/[^A-Za-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'safety-form';
  return `${base}-${id.slice(0, 8)}.pdf`;
}

export async function downloadSubmissionPdf(id: string, filename: string): Promise<void> {
  try {
    const res = await api.safety.getSubmissionPdf(id);
    saveBlobAs(res.data as Blob, filename);
  } catch (err) {
    toast.error(await getBlobApiErrorMessage(err, 'Could not download the PDF'));
  }
}

/** MUST be called straight from the click handler. */
export function printSubmissionPdf(id: string): Promise<void> {
  const win = claimBlobTab();
  if (!win) {
    toast.error(POPUP_BLOCKED_MESSAGE);
    return Promise.resolve();
  }
  return api.safety.getSubmissionPdf(id).then(
    res => {
      showBlobInTab(win, res.data as Blob);
      toast.success(PRINT_IN_TAB_MESSAGE);
    },
    async err => {
      win.close();
      toast.error(await getBlobApiErrorMessage(err, 'Could not open the PDF'));
    },
  );
}
